/**
 * On-map HUD shown only in 3DS (X-RAY) view mode.
 * Explains colour / depth so the underground stack is readable.
 */
export function SubstructureLegend() {
  return (
    <aside className="substructure-legend" aria-label="Underground layer legend">
      <header className="substructure-legend-head">
        <span className="eyebrow mono">X-RAY · KMITL</span>
        <span className="caption mono" style={{ color: "var(--ink-low)" }}>REF corridors</span>
      </header>
      <ul className="substructure-legend-list">
        <li>
          <span className="sub-swatch" style={{ background: "rgb(245, 158, 11)" }} />
          <span>Electricity (MEA) · −2 m</span>
        </li>
        <li>
          <span className="sub-swatch" style={{ background: "rgb(56, 189, 248)" }} />
          <span>Water (MWA) · −3 m</span>
        </li>
        <li>
          <span className="sub-swatch" style={{ background: "rgb(16, 185, 129)" }} />
          <span>Drainage / khlong · −4 m</span>
        </li>
        <li>
          <span className="sub-swatch" style={{ background: "rgb(110, 75, 58)" }} />
          <span>SRT / ARL corridor · grade</span>
        </li>
      </ul>
      <p className="caption" style={{ color: "var(--ink-low)", margin: 0 }}>
        Buildings ghosted so buried lines read through. MEA/MWA lines follow major
        road corridors until as-built CAD is wired.
      </p>
    </aside>
  );
}
